/* eslint-disable import/no-deprecated */
import React from 'react';
import { Tooltip } from '../../components/Tooltip';
import { Icon } from '../../deprecated/Icon';
import { identifyComponent } from '../../util';
import { Box } from '../Box';

export const SelectMenuTooltip = (
  props: Omit<React.ComponentProps<typeof Tooltip>, 'children' | 'compact'>,
) => (
  <Tooltip
    data-component="SelectMenuTooltip"
    testId="select-menu-tooltip"
    {...props}
    {...identifyComponent('select-menu-tooltip', props)}
  >
    <Box marginLeft={8}>
      <Icon size={16} name="information-primary" color="neutrals-n7" />
    </Box>
  </Tooltip>
);
